import { currencies } from "../constants";

export function getCurrencySymbol(currency: string) {
    return currencies[currency] || '€';
}



// WEBPACK FOOTER //
// ./src/modules/shared/helpers/CurrencyHelper.tsx